import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[appSelectOnFocus]'
})
export class SelectOnFocusDirective {
	constructor(private el: ElementRef) {}

	@HostListener('focus', ['$event'])
	@HostListener('click', ['$event'])
	onFocus() {
		const el = this.el.nativeElement as HTMLInputElement | HTMLTextAreaElement;
		const value = el.value;
		const len = value?.length ?? 0;
		if (!len) {
			return;
		}
		// setSelectionRange throws InvalidStateError for type="number" and several other input types (WebKit).
		if (el instanceof HTMLInputElement) {
			const t = (el.type || 'text').toLowerCase();
			const canSelect =
				t === 'text' ||
				t === 'search' ||
				t === 'url' ||
				t === 'tel' ||
				t === 'password' ||
				t === '';
			if (!canSelect) {
				return;
			}
		}
		try {
			el.setSelectionRange(0, len);
		} catch {
			/* non-text-like control */
		}
	}
	onClick() {
		const el = this.el.nativeElement;
		el.focus();
	}
}
